import Index from '../../pages/tideng/third/index';
import Pc from '../../pages/tideng/third/pc/index.vue';
const base = 'third';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/pc`,
    name: `${base}-index`,
    component: Pc
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Index
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/tideng/third.js